<template>
  <div class="loading-page">
    <a-spin size="large" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue"

import { checkAccountStatus } from "@/utils/user"
// 全屏白色无透明度 loading 页面，适用于全局或模块加载白屏场景
onMounted(() => {
  // 如果accountsList没有账号 跳转到init
  checkAccountStatus()
})
</script>

<style scoped>
.loading-page {
  position: fixed;
  inset: 0;
  top: 50%;
  left: 50%;
  z-index: 3000;
  width: 36px;
  height: 36px;
  transform: translate(-50%, -50%);
}

:deep(.ant-spin) {
  position: static !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
}

:deep(.ant-spin .ant-spin-mask) {
  background: #fff !important;
  opacity: 1 !important;
}
</style>
